import { v4 as uuidV4 } from 'uuid';

import { IHomepageMainNavItems, NavMainItems } from '@/types/homepage.types';
import { updateTranslateKey } from './update-translation-key';
import { staticTranslator } from '../i18n/config';
import { LanguagesAbbr, TranslateString } from '@/types/translation.types';

export const GetMultipleSessionsMainNavItems = (
  defaultLanguage: LanguagesAbbr,
  homeUuid?: string,
  sessionUuid?: string,
  leaderboardNavIcon?: IHomepageMainNavItems
): IHomepageMainNavItems[] => {
  const navItems = [
    {
      uuid: homeUuid?.length ? homeUuid : uuidV4(),
      name: NavMainItems.Home,
      custom_name: updateTranslateKey({
        translateString: GetDefaultTranslateString(),
        input: staticTranslator.getValue(defaultLanguage, 'homepage', NavMainItems.Home),
        baseLanguage: defaultLanguage,
        language: defaultLanguage,
      }),
      is_on: true,
    },
    // do not change param is added so that "Agenda" is shown by default when a user adds a session to a single session event
    {
      uuid: sessionUuid?.length ? sessionUuid : uuidV4(),
      name: NavMainItems.Sessions,
      custom_name: updateTranslateKey({
        translateString: GetDefaultTranslateString(),
        input: staticTranslator.getValue(defaultLanguage, 'homepage', NavMainItems.Sessions),
        baseLanguage: defaultLanguage,
        language: defaultLanguage,
        doNotChange: true,
      }),
      is_on: true,
    },
  ];
  if (leaderboardNavIcon) {
    navItems.push(leaderboardNavIcon);
  }
  return navItems;
};

export const GetDefaultTranslateString = (text?: string): TranslateString => ({
  base: text ?? '',
  changed: '',
});

//This should all be taken care of in the API, but leaving it in as a fallback for now
export const GetDefaultMainNavItems = (defaultLanguage: LanguagesAbbr): IHomepageMainNavItems[] => [
  {
    uuid: uuidV4(),
    name: NavMainItems.Home,
    custom_name: updateTranslateKey({
      translateString: GetDefaultTranslateString(),
      input: staticTranslator.getValue(defaultLanguage, 'homepage', NavMainItems.Home),
      baseLanguage: defaultLanguage,
      language: defaultLanguage,
    }),
    is_on: true,
  },
  {
    uuid: uuidV4(),
    name: NavMainItems.Session,
    custom_name: updateTranslateKey({
      translateString: GetDefaultTranslateString(),
      input: staticTranslator.getValue(defaultLanguage, 'homepage', NavMainItems.Session),
      baseLanguage: defaultLanguage,
      language: defaultLanguage,
    }),
    is_on: true,
  },
];
